import { render, staticRenderFns } from "./FAQComponent.vue?vue&type=template&id=cfa7de2c"
import script from "./FAQComponent.vue?vue&type=script&lang=js"
export * from "./FAQComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports